import {
  GET_ROOM_PRICES_LIST,
  GET_ROOM_PRICES_LIST_SUCCESS,
  CREATE_ROOM_PRICE,
  CREATE_ROOM_PRICE_SUCCESS,
  UPDATE_ROOM_PRICE,
  UPDATE_ROOM_PRICE_SUCCESS,
  DELETE_ROOM_PRICE,
  DELETE_ROOM_PRICE_SUCCESS,
  GET_ROOM_PRICE_BY_ID,
  GET_ROOM_PRICE_BY_ID_SUCCESS,
} from '../storeTypes';

const INIT_STATE = {
  loader: false,
  roomPrices: [],
  currentRoomPrice: null,
};

function RoomPriceReducer(state = INIT_STATE, action) {
  switch (action.type) {
    case GET_ROOM_PRICES_LIST: {
      return {
        ...state,
        roomPrices: [],
        loader: true,
      };
    }

    case GET_ROOM_PRICES_LIST_SUCCESS: {
      return {
        ...state,
        loader: false,
        roomPrices: action.payload,
      };
    }

    case CREATE_ROOM_PRICE: {
      return {
        ...state,
        loader: true,
      };
    }

    case CREATE_ROOM_PRICE_SUCCESS: {
      return {
        ...state,
        loader: false,
        roomPrices: [...state.roomPrices, action.payload],
      };
    }

    case UPDATE_ROOM_PRICE: {
      return {
        ...state,
        loader: true,
      };
    }

    case UPDATE_ROOM_PRICE_SUCCESS: {
      return {
        ...state,
        loader: false,
        roomPrices: state.roomPrices.map(price =>
          price.id === action.payload.id ? action.payload : price
        ),
      };
    }

    case DELETE_ROOM_PRICE: {
      return {
        ...state,
        loader: true,
      };
    }

    case DELETE_ROOM_PRICE_SUCCESS: {
      return {
        ...state,
        loader: false,
        roomPrices: state.roomPrices.filter(price => price.id !== action.payload),
      };
    }

    case GET_ROOM_PRICE_BY_ID: {
      return {
        ...state,
        currentRoomPrice: null,
        loader: true,
      };
    }

    case GET_ROOM_PRICE_BY_ID_SUCCESS: {
      return {
        ...state,
        loader: false,
        currentRoomPrice: action.payload,
      };
    }

    default: {
      return state;
    }
  }
}

export default RoomPriceReducer;



